import { Autocomplete, TextField, Box, FormControl } from '@mui/material';
import { matchSorter } from 'match-sorter';

export function FilterSelector({
  sorter,
  sortKeys,
  isVisible,
  selectedOption,
  renderOption,
  onChange,
  optionKey,
  optionTitleKey,
  optionContentKey,
  optionLabelKey,
  inputLabel,
  InputLabelProps,
  dark = true,
  sx,
  ...props
}) {
  const filterOptions = (opts, { inputValue }) =>
    matchSorter(opts, inputValue, { sorter, keys: sortKeys });

  if (!isVisible) return null;

  return (
    <FormControl
      sx={{
        width: { xs: '80%', sm: 250 },
        position: 'relative',
        marginLeft: { xs: 0, sm: 1 },
        backgroundColor: dark ? '#303030' : undefined,
        color: dark ? 'white' : undefined,

        '& .MuiAutocomplete-paper': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },

        [[
          '& .MuiAutocomplete-noOptions',
          '& .MuiAutocomplete-listbox',
          '& .MuiInputBase-root',
          '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root',
        ].join(',')]: {
          backgroundColor: dark ? '#303030' : undefined,
          color: dark ? 'white' : undefined,
        },

        [[
          '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"].Mui-focused',
          '& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused',
          '& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focusVisible',
        ].join(',')]: {
          backgroundColor: dark ? '#629749' : undefined,
        },

        '& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused': {
          color: dark ? 'white' : undefined,
        },

        '& .MuiInputBase-root:after': {
          borderColor: dark ? 'white' : undefined,
        },

        ...sx,
      }}
    >
      <Autocomplete
        filterOptions={filterOptions}
        autoHighlight
        blurOnSelect
        disableClearable
        disablePortal
        value={selectedOption}
        noOptionsText="Nothing Found"
        size="small"
        onChange={(_, option) => onChange(option)}
        getOptionLabel={(opt) => opt[optionLabelKey] || ''}
        isOptionEqualToValue={(option, value) => option.guid === value.guid}
        renderOption={(optionProps, option) => (
          <Box
            component="li"
            {...optionProps}
            key={option[optionKey]}
            title={option[optionTitleKey || optionKey]}
          >
            {option[optionContentKey]}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={inputLabel}
            variant="filled"
            InputLabelProps={InputLabelProps}
            inputProps={{
              ...params.inputProps,
              sx: { color: dark ? 'white' : undefined },
              autoComplete: 'off',
            }}
          />
        )}
        {...props}
      />
    </FormControl>
  );
}
